/**
 * #screenshot.ts
 *
 * Code generated by ts-proto. DO NOT EDIT.
 * @packageDocumentation
 */
/* eslint-disable */
import _m0 from "protobufjs/minimal.js";
import { messageTypeRegistry } from "../../../../../typeRegistry.js";
function createBaseWebViewScreenshotRequestEvent() {
    return {};
}
export const WebViewScreenshotRequestEvent = {
    $type: "devvit.ui.effects.web_view.v1alpha.WebViewScreenshotRequestEvent",
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWebViewScreenshotRequestEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return WebViewScreenshotRequestEvent.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseWebViewScreenshotRequestEvent();
        return message;
    },
};
messageTypeRegistry.set(WebViewScreenshotRequestEvent.$type, WebViewScreenshotRequestEvent);
function createBaseWebViewScreenshotResponseEffect() {
    return { dataUrl: undefined, error: undefined };
}
export const WebViewScreenshotResponseEffect = {
    $type: "devvit.ui.effects.web_view.v1alpha.WebViewScreenshotResponseEffect",
    encode(message, writer = _m0.Writer.create()) {
        if (message.dataUrl !== undefined) {
            writer.uint32(10).string(message.dataUrl);
        }
        if (message.error !== undefined) {
            writer.uint32(18).string(message.error);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWebViewScreenshotResponseEffect();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.dataUrl = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.error = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            dataUrl: isSet(object.dataUrl) ? globalThis.String(object.dataUrl) : undefined,
            error: isSet(object.error) ? globalThis.String(object.error) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.dataUrl !== undefined) {
            obj.dataUrl = message.dataUrl;
        }
        if (message.error !== undefined) {
            obj.error = message.error;
        }
        return obj;
    },
    create(base) {
        return WebViewScreenshotResponseEffect.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseWebViewScreenshotResponseEffect();
        message.dataUrl = object.dataUrl ?? undefined;
        message.error = object.error ?? undefined;
        return message;
    },
};
messageTypeRegistry.set(WebViewScreenshotResponseEffect.$type, WebViewScreenshotResponseEffect);
function isSet(value) {
    return value !== null && value !== undefined;
}
